const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Account } from './Account';
import { MomentSoldFF } from './MomentSoldFF';
import * as telegram from "./telegram"
import * as utils from "./utils"

export class FastFingerList extends BaseObject {
  public moments: MomentSoldFF[] = null
  public numMoments: number = null
  public computedDate: Date = null
  public flowAddress: string = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super()
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (this.moments) this.moments = this.moments.map((po) => new MomentSoldFF(po))
    if (typeof this.computedDate === 'string') this.computedDate = new Date(this.computedDate)
  }


  public isSafe(): boolean {
    return true
  }



}




(async () => {
})();
